// 认证管理工具
export const auth = {
  // 设置token
  setToken(token) {
    localStorage.setItem('token', token)
  },
  
  // 获取token
  getToken() {
    return localStorage.getItem('token')
  },
  
  // 清除token
  clearToken() {
    localStorage.removeItem('token')
  },
  
  // 检查是否已认证
  isAuthenticated() {
    return !!this.getToken()
  },
  
  // 设置认证信息
  setAuthInfo(authData) {
    if (authData.token) {
      this.setToken(authData.token)
    }
    if (authData.userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(authData.userInfo))
    }
  },
  
  // 获取用户信息
  getUserInfo() {
    const userInfo = localStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : null
  },
  
  // 清除所有认证信息
  clearAuth() {
    this.clearToken()
    localStorage.removeItem('userInfo')
  }
}

export default auth
